import { CollegeSearchFilters } from '@common-types';

export interface CheckboxOption {
  label: string;
  value: string | boolean;
}

export interface Option {
  label: string;
  value: string;
}

export interface RadioOption extends Option {
  id?: string;
  value: string;
}

export interface SelectedFiltersProps extends Option {
  key: keyof CollegeSearchFilters;
}

export interface AutocompleteOption extends Option {
  // eslint-disable-next-line
  additionData?: Option[];
  isDisabled?: boolean;
}

export interface FavoriteMajorCipCodes {
  cipCodes: string[];
}

export enum Order {
  asc = 'asc',
  desc = 'desc',
}
